export const enums = {
	DEGREE_OF: ['Contains', 'Traces of'],
};
